export default __webpack_public_path__ + "static/media/gigot.6efbb8cc.jpg";